import { render, staticRenderFns } from "./contactFollow.vue?vue&type=template&id=1efbe7e2&scoped=true"
import script from "./contactFollow.vue?vue&type=script&lang=js"
export * from "./contactFollow.vue?vue&type=script&lang=js"
import style0 from "./contactFollow.vue?vue&type=style&index=0&id=1efbe7e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efbe7e2",
  null
  
)

export default component.exports